import { useDidMount } from 'hooks';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import firebase from 'services/firebase';

const useRprod = (id) => {
  // get and check if product exists in store
  //const storeProduct = useSelector((state) => state.products.items.find((item) => item.id === id));

  const [rprod, setrprod] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const didMount = useDidMount(true);

  useEffect(() => {
    (async () => {

      try {
        if (!rprod || rprod.id !== id) {
          setLoading(true);
          const doc = await firebase.getuidByPid(id);

          if (doc.exists) {
            const data = { ...doc.data(), id: doc.ref.id };

            if (didMount) {
              setrprod(data);
              setLoading(false);
            }
          } else {
            setError('User not found.');
          }
        }
      } catch (err) {
        if (didMount) {
          setLoading(false);
          setError(err?.message || 'Something went wrong.');
        }
      }
    })();
  }, [id]);

  return { rprod, isLoading, error };
};

export default useRprod;
